<template>
  <md-list-item v-if="displayObj.show == true" @click="atClick">
    <md-icon v-if="displayObj">{{ displayObj.icon }}</md-icon>
    <span v-if="displayObj" class="md-list-item-text">{{ displayObj.label }}</span>
  </md-list-item>
</template>

<script>
  import localDataFunctions from '../../localDataFunctions';

  export default {
    name: 'menuListItem',
    components: {},
    mixins: ['localDataFunctions'],
    props: ['displayObj'],
    data: function () {
      return {}
    },
    methods: {
      atClick(event) {
        this.$emit('click', event);
      },
    },
  }
</script>

<style>

</style>
